import React from 'react';
import styled from 'styled-components';
import Error from '../common/Error';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

function Main() {
  return (
    <Container>
      <Error message="Something went wrong" />
    </Container>
  );
}

export default Main;
